import { PaymentMethod } from '~/shared/constants/paymentConstants'
import { IAction } from '~/shared/store/types'
import { IPaymentConfig } from '~/shared/types/configTypes'

import {
  RESET_3D_SECURE_IFRAME_URL,
  SET_3D_SECURE_IFRAME_URL,
  SET_IS_ALREADY_BOUGHT,
  SET_IS_DIRECT_STRIPE_PAYMENT_ENABLED,
  SET_IS_FIRST_PAYMENT_RETRY_PASSED,
  SET_IS_FORCE_3DS,
  SET_IS_PRIMER_RETRY_PROCESSING,
  SET_IS_SUBSCRIPTION_PURCHASE_INITIATED,
  SET_PAYMENT_CONFIG,
  SET_PAYMENT_PROCESSOR_NAMES,
  SET_PRIMER_CLIENT_TOKEN,
  SET_STRIPE_CLIENT_SECRET,
  SET_STRIPE_QUICK_PAY_CHECKED,
  SET_STRIPE_QUICK_PAY_METHOD,
} from '../actionTypes'

export interface IPaymentProcessorNames {
  processorName: string
  applePayProcessorName: string
  googlePayProcessorName: string
  paypalProcessorName: string
}

export function setPaymentConfigAction(
  payload: IPaymentConfig,
): IAction<IPaymentConfig> {
  return {
    type: SET_PAYMENT_CONFIG,
    payload,
  }
}

export const setIsPrimerRetryProcessing = (
  payload: boolean,
): IAction<boolean> => ({
  type: SET_IS_PRIMER_RETRY_PROCESSING,
  payload,
})

export const setIsFirstPaymentRetryPassedAction = (
  payload: boolean,
): IAction<boolean> => ({
  type: SET_IS_FIRST_PAYMENT_RETRY_PASSED,
  payload,
})

export const setPrimerClientTokenAction = (
  payload: string,
): IAction<string> => ({
  type: SET_PRIMER_CLIENT_TOKEN,
  payload,
})

export const set3DSecureIframeUrlAction = (
  payload: string,
): IAction<string> => ({
  type: SET_3D_SECURE_IFRAME_URL,
  payload,
})

export const reset3DSecureIframeUrlAction = (): IAction<never> => ({
  type: RESET_3D_SECURE_IFRAME_URL,
})

export const setStripeClientSecretAction = (
  payload: string,
): IAction<string> => ({
  type: SET_STRIPE_CLIENT_SECRET,
  payload,
})

export const setStripeQuickPayMethodAction = (
  payload: PaymentMethod | null,
): IAction<PaymentMethod | null> => ({
  type: SET_STRIPE_QUICK_PAY_METHOD,
  payload,
})

export const setStripeQuickPayCheckedAction = (): IAction<never> => ({
  type: SET_STRIPE_QUICK_PAY_CHECKED,
})

export const setIsSubscriptionPurchaseInitiated = (
  payload: boolean,
): IAction<boolean> => ({
  type: SET_IS_SUBSCRIPTION_PURCHASE_INITIATED,
  payload,
})

export const setIsAlreadyBoughtAction = (
  payload: boolean,
): IAction<boolean> => ({
  type: SET_IS_ALREADY_BOUGHT,
  payload,
})

export const setIsForce3DSAction = (payload: boolean): IAction<boolean> => ({
  type: SET_IS_FORCE_3DS,
  payload,
})

export const setPaymentProcessorNamesAction = (
  payload: IPaymentProcessorNames,
): IAction<IPaymentProcessorNames> => ({
  type: SET_PAYMENT_PROCESSOR_NAMES,
  payload,
})

export const setIsDirectStripePaymentEnabledAction = (
  payload: boolean,
): IAction<boolean> => ({
  type: SET_IS_DIRECT_STRIPE_PAYMENT_ENABLED,
  payload,
})
